module.exports = __webpack_public_path__ + "img/inactive-form-field.0cded1b2.svg";